import React, { useState } from 'react';
import { Package, FileStack, Check, FileKey } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { copy } from '../../copy';
import { SlideOver } from './SlideOver';
interface ExportPackageProps {
  open: boolean;
  onClose: () => void;
}
export function ExportPackage({
  open,
  onClose
}: ExportPackageProps) {
  const navigate = useNavigate();
  const {
    exportPackage
  } = copy.workflow;
  const [selected, setSelected] = useState<Record<string, boolean>>(() => Object.fromEntries(exportPackage.items.map(it => [it.id, it.enabled])));
  const [generated, setGenerated] = useState(false);
  const toggle = (id: string) => setSelected(prev => ({
    ...prev,
    [id]: !prev[id]
  }));
  const count = Object.values(selected).filter(Boolean).length;
  return <SlideOver open={open} onClose={onClose} title={exportPackage.title} subtitle={exportPackage.subtitle} footer={<button onClick={() => {
    setGenerated(true);
    setTimeout(() => setGenerated(false), 2000);
  }} disabled={count === 0} className="flex w-full items-center justify-center gap-2 rounded-xl bg-blue-500 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-600 disabled:cursor-not-allowed disabled:opacity-40" data-id="element-105">
          {generated ? <>
              <Check size={16} data-id="element-106" /> Package generated
            </> : <>
              <Package size={16} data-id="element-107" /> {exportPackage.exportButton} ({count})
            </>}
        </button>} data-id="element-104">
      <div className="space-y-3" data-id="element-108">
        {exportPackage.items.map(item => {
        const isOn = selected[item.id];
        return <button key={item.id} type="button" onClick={() => toggle(item.id)} aria-pressed={isOn} className={`flex w-full items-start gap-3 rounded-xl border p-3 text-left transition-colors ${isOn ? 'border-blue-200 dark:border-blue-800 bg-blue-50/60 dark:bg-blue-900/20' : 'border-slate-200 dark:border-[#333] bg-slate-50 dark:bg-[#222] hover:border-slate-300 dark:hover:border-[#444]'}`} data-id="element-109">
              <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border transition-colors ${isOn ? 'border-blue-500 bg-blue-500 text-white' : 'border-slate-300 dark:border-[#444] bg-white dark:bg-[#1a1a1a]'}`} data-id="element-110">
                {isOn && <Check size={13} strokeWidth={3} data-id="element-111" />}
              </span>
              <span className="min-w-0 flex-1" data-id="element-112">
                <span className="block text-sm font-medium text-slate-900 dark:text-[#e5e5e5]" data-id="element-113">
                  {item.label}
                </span>
                <span className="mt-0.5 block text-xs text-slate-500 dark:text-[#a3a3a3]" data-id="element-114">
                  {item.description}
                </span>
              </span>
            </button>;
      })}
      </div>

      <button onClick={() => {
      onClose();
      navigate('/case/files/redact');
    }} className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl border-2 border-purple-200 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/20 px-4 py-3 text-sm font-semibold text-purple-700 dark:text-purple-300 hover:bg-purple-100 dark:hover:bg-purple-900/30 active:scale-[0.98] transition-all" data-id="element-115">
        <FileKey size={16} strokeWidth={2.5} data-id="element-116" />
        Redact Sensitive Information
      </button>

      <div className="mt-5 flex items-start gap-2 rounded-xl border border-slate-200 dark:border-[#333] bg-slate-50 dark:bg-[#222] p-3" data-id="element-117">
        <FileStack size={16} className="mt-0.5 shrink-0 text-slate-400 dark:text-[#737373]" data-id="element-118" />
        <p className="text-xs leading-relaxed text-slate-500 dark:text-[#a3a3a3]" data-id="element-119">
          {exportPackage.manifestNote}
        </p>
      </div>
    </SlideOver>;
}